import { render, staticRenderFns } from "./DialogConsentGroupOnechatCreate.vue?vue&type=template&id=aa50b1d4&scoped=true&"
import script from "./DialogConsentGroupOnechatCreate.vue?vue&type=script&lang=js&"
export * from "./DialogConsentGroupOnechatCreate.vue?vue&type=script&lang=js&"
import style0 from "./DialogConsentGroupOnechatCreate.vue?vue&type=style&index=0&id=aa50b1d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa50b1d4",
  null
  
)

export default component.exports